(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('virtualFairsReportController', virtualFairsReportController);
    virtualFairsReportController.$inject = ['VirtualFairService', 'ExpoService', '$uibModal'];
    function virtualFairsReportController(VirtualFairService, ExpoService, $uibModal) {
        var vm = this;
        vm.result  = [];

        function active() {

        }

        active();
    }
})();